import { Injectable } from '@angular/core';
import { GenericService } from '../../../../core/services/GenericService';
import { ApiService } from '../../../../core/services';
import { IProductMaster } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class ProductMasterService extends GenericService<IProductMaster> {
  protected baseUrl = '/reports/product-master';

  constructor(public apiService: ApiService) {
    super(apiService);
  }
}
